import {
  Box,
  IconInfo,
  IconTick,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import LayoutBox from 'src/components/LayoutBox/LayoutBox';
import type { DesktopFeatureConfig } from 'src/data/listing-products/desktop';

interface CellContentProps {
  featureConfig: DesktopFeatureConfig;
}

const FeatureCellContent = ({ featureConfig }: CellContentProps) => {
  switch (featureConfig) {
    case 'enabled':
      return (
        <LayoutBox alignment="centre">
          <Box data-testid={createTestId('enabled')}>
            <IconTick tone="info" size="large" />
          </Box>
        </LayoutBox>
      );
    case 'addOn450':
      return (
        <LayoutBox alignment="centre">
          <Box data-testid={createTestId('addOn450')}>
            <Stack space="small" align="center">
              <IconInfo size="large" />
              <Text align="center">
                Available to purchase for an additional $450 + GST
              </Text>
            </Stack>
          </Box>
        </LayoutBox>
      );
    case 'addOn650':
      return (
        <LayoutBox alignment="centre">
          <Box data-testid={createTestId('addOn650')}>
            <Stack space="small" align="center">
              <IconInfo size="large" />
              <Text align="center">
                Available to purchase for an additional $650 + GST
              </Text>
            </Stack>
          </Box>
        </LayoutBox>
      );
    case 'payPerEnquiry':
      return (
        <LayoutBox alignment="centre">
          <Box data-testid={createTestId('payPerEnquiry')}>
            <Stack space="small" align="center">
              <Inline alignY="bottom" space="xsmall">
                <Text size="large" tone="info">
                  $80 per enquiry
                </Text>
                <Text tone="info">+ GST</Text>
              </Inline>

              <Text tone="info">Capped at $960 + GST</Text>

              <Text size="small" tone="info">
                <i>Subsequent enquires are free</i>
              </Text>
            </Stack>
          </Box>
        </LayoutBox>
      );
    case '6month':
      return (
        <LayoutBox alignment="centre">
          <Box data-testid={createTestId('6month')}>
            <Stack space="none" align="center">
              <Text align="center">6 months</Text>
            </Stack>
          </Box>
        </LayoutBox>
      );
    case 'lus':
      return (
        <LayoutBox alignment="centre">
          <Box data-testid={createTestId('lus')}>
            <Stack space="none" align="center">
              <Text align="center">List until sold</Text>
            </Stack>
          </Box>
        </LayoutBox>
      );
    case 'disabled':
      return (
        <LayoutBox alignment="centre">
          <Box data-testid={createTestId('disabled')}> </Box>
        </LayoutBox>
      );
  }
};

const createTestId = (suffix: string) =>
  `packages-desktop-feature-content-${suffix}`;

export default FeatureCellContent;
